import React, { useEffect, useState, useRef } from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { Box, borderBottom, height, positions, width } from "@mui/system";
import {isMobileOnly} from "react-device-detect"

// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import ALLSUBURBS from "../utils/constants";
// The following is required to stop "npm build" from transpiling mapbox code.
// notice the exclamation point in the import.
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_KEY as string;

const MapBox = () => {
  const mapContainer = useRef<any>(null);
  const map = useRef<mapboxgl.Map | null>(null);
  const [selectedCrimeProperties, setSelectedCrimeProperties] =
    useState<any>(null);

  useEffect(() => {
    if (map.current) return; // initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v12", // style URL
      center: [115.868, -31.917], // starting position [lng, lat]
      zoom: 9, // starting zoom
      minZoom: 7,
      maxZoom: 15,
    });

    map.current &&
      map.current.addControl(new mapboxgl.NavigationControl(), "top-right");

    map.current.on("load", () => {
      // add the 2022-2023 crime layers
      if (!map.current) return;
      map.current.addSource(`2022_23Tileset`, {
        type: "vector",
        url: `mapbox://pascalsun.0qfd3o6j`,
      });

      map.current.addLayer(
        {
          id: `2022_23Layer`,
          type: "fill",
          source: "2022_23Tileset",
          "source-layer": "2022_23_all_suburb",
          paint: {
            "fill-color": [
              "step",

              [
                "case",
                 ["==", ["get", "is_metro"], true],
                // [
                //   "/",
                [
                  "+",
                  ["get", "2022_23.Homicide.TotalAnnual"],
                  ["get", "2022_23.Sexual_Offences.TotalAnnual"],
                  ["get", "2022_23.Assault_(Family).TotalAnnual"],
                  ["get", "2022_23.Assault_(Non-Family).TotalAnnual"],
                  ["get", "2022_23.Threatening_Behaviour_(Family).TotalAnnual"],
                  [
                    "get",
                    "2022_23.Threatening_Behaviour_(Non-Family).TotalAnnual",
                  ],
                  ["get", "2022_23.Deprivation_of_Liberty.TotalAnnual"],
                  ["get", "2022_23.Robbery.TotalAnnual"],
                  ["get", "2022_23.Dwelling_Burglary.TotalAnnual"],
                  ["get", "2022_23.Non-Dwelling_Burglary.TotalAnnual"],
                  ["get", "2022_23.Stealing_of_Motor_Vehicle.TotalAnnual"],
                  ["get", "2022_23.Stealing.TotalAnnual"],
                  ["get", "2022_23.Property_Damage.TotalAnnual"],
                  ["get", "2022_23.Arson.TotalAnnual"],
                  ["get", "2022_23.Drug_Offences.TotalAnnual"],
                  ["get", "2022_23.Graffiti.TotalAnnual"],
                  ["get", "2022_23.Fraud_&_Related_Offences.TotalAnnual"],
                  [
                    "get",
                    "2022_23.Breach_of_Violence_Restraint_Order.TotalAnnual",
                  ],
                ],
              
                //   ["get", "Population_2021"],
                
                // ],
                0,
              ],
              "rgba(0, 0, 0, 0)", //filterout non metro area data
              1,
              "#FFEDA0",
              10,
              "#FEB24C",
              50,
              "#FEB24C",
              100,
              "#FD8D3C",
              200,
              "#FC4E2A",
              500,
              "#E31A1C",
              850,
              "#BD0026",
              1500,
              "#800026",
            ],
            "fill-opacity": 0.8,
            "fill-outline-color": "#fff",
          },
        }
        // Place polygons under labels, roads and buildings.
        // ,"building"
      );
    
       // for click highlight
    map.current.addLayer({
      id: `highlight`,
      type: "line",
      source: "2022_23Tileset",
      "source-layer": "2022_23_all_suburb",
      'paint': {
        'line-color': '#000',
'line-width': 3 
    },
    'filter': ['in', 'suburb', '']
    });
    });



    map.current.on("click", "2022_23Layer", (e: any) => {
      
      if (e.features[0].properties?.is_metro) {
        let max = {type: '', value: 0};
        let crimeRate;
        if (!e.features[0].properties.totalCrime) {
          let totalCrime = 0;
          Object.keys(e.features[0].properties).map((key) => {
            if (key.includes("TotalAnnual") && !key.includes("Rank")) {
              totalCrime += e.features[0].properties[key];
              if(e.features[0].properties[key] > max.value) {
                max.type = key.includes("2022_23") ? key.split(".")[1] : key;
                max.value = e.features[0].properties[key]
              }
            }
          });
          e.features[0].properties.totalCrime = totalCrime;
          e.features[0].properties.maxCrime = max;


          crimeRate = e.features[0].properties?.Population_2021 === 0
          ? "No Population Data Available to Calculate Crimes Rate"
          : `Crimes per 100 people: ${(
              (e.features[0].properties?.totalCrime /
              e.features[0].properties?.Population_2021) *
              100
            ).toFixed(2)}`

            e.features[0].properties.crimeRate = crimeRate;

        }

        setSelectedCrimeProperties(e.features[0].properties);
        console.log(e.features[0].properties);

        //click highlight
        const selectSuburb = e.features[0].properties.suburb;
        map.current && map.current.setFilter('highlight', ['in', 'suburb', selectSuburb.toUpperCase()]);

        //mobile
        if (isMobileOnly && map.current) {

          new mapboxgl.Popup()
              .setLngLat(e.lngLat)
              .setHTML(`
                  <div>
                  <h3>${e.features[0].properties?.LOC_NAME}</h3>
                  <p> Total Crime Case: ${e.features[0].properties?.totalCrime}</p>
                  <p> Type and Amount of Most Crimes: ${max.type} / ${max.value}</p>
                  <p> Population_2021: ${e.features[0].properties?.Population_2021 }</p>
                  <p> ${crimeRate}</p>
                  </div>
              `)

              .addTo(map.current);
      }
      } 
      else {
        setSelectedCrimeProperties(null);
        map.current && map.current.setFilter('highlight', ['in', 'suburb', '']);
      }
    });

  });

  const colors = [
    "#FFEDA0",
    "#FED976",
    "#FEB24C",
    "#FD8D3C",
    "#FC4E2A",
    "#E31A1C",
    "#BD0026",
    "#800026",
  ];

  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <div>
        <div
          ref={mapContainer}
          className="map-container"
          style={{
            width: (selectedCrimeProperties && !isMobileOnly) ? "75vw" : "100vw",
          }}
        />
        <div className="map-overlay" id="legend">
          <span style={{ fontSize: 12, padding: 5 }}>Best</span>
          {colors.map((color, i) => {
            return (
              <div key={color}>
                <span
                  className="legend-key"
                  style={{ backgroundColor: color }}
                ></span>
                {/* <span> {ranks[i]}</span> */}
              </div>
            );
          })}
          <span style={{ fontSize: 12, padding: 5 }}>Worst</span>
        </div>
      </div>

      <div id="side-widget" style={{ width: "25vw", height: "100vh" }}>
        {(selectedCrimeProperties && !isMobileOnly) && (
          <TableContainer
            component={Paper}
            sx={{ maxWidth: "25vw", height: "100vh" }}
          >
            <Table
              aria-label="my table"
              size="small"
              sx={{ maxWidth: "25vw", height: "90vh" }}
            >
              <TableBody>
                {Object.keys(selectedCrimeProperties).map((key) => {
                  if (
                    key.includes("LOC_NAME") ||
                    (key.includes("TotalAnnual") && !key.includes("Rank")) ||
                    key.includes("Population_2021")
                  ) {
                    return (
                      <TableRow key={key}>
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{ width: "20%", padding: "3px" }}
                        >
                          {key.includes("2022_23") ? key.split(".")[1] : key}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ width: "20%", padding: "3px" }}
                        >
                          {selectedCrimeProperties[key]}
                        </TableCell>
                      </TableRow>
                    );
                  }
                  return null;
                })}
                <TableRow>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ width: "20%", padding: "3px", fontWeight: "bold" }}
                  >
                    Type and Amount of Most Crimes
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ width: "20%", padding: "3px", fontWeight: "bold" }}
                  >
                    {selectedCrimeProperties.maxCrime.type} {" : "}
                    {selectedCrimeProperties.maxCrime.value}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ width: "20%", padding: "3px", fontWeight: "bold" }}
                  >
                    Total Crime Case
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ width: "20%", padding: "3px", fontWeight: "bold" }}
                  >
                    {selectedCrimeProperties.totalCrime}
                  </TableCell>
                </TableRow>
                

                <TableRow>
                  <TableCell
                    align="center"
                    colSpan={2}
                    sx={{ fontSize: 16, fontWeight: "bold" }}
                  >
                    {selectedCrimeProperties.crimeRate}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <Typography
              variant="body2"
              component="p"
              align="center"
              gutterBottom
              sx={{
                fontSize: 12,
                color: "gray",
                height: "10vh",
                fontWeight: "bold",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Box>Data sourced from WA Police website</Box>
              <Box>(2022 to 2023 data only)</Box>
            </Typography>
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default MapBox;
